import { SEOConfig } from '@betterfunnel/types';
import { useCallback, useContext } from 'react';
import { SEOForm } from '../../../components/settings/SEOForm';
import SettingSectionTitle from '../../../components/settings/SettingSectionTitle';
import { DashboardContext } from '../../../contexts/DashboardContext';
import { SnackbarContext } from '../../../contexts/SnackbarContext';
import { UserContext } from '../../../contexts/UserContext';
import { updateDynamicPage } from '../../../services/DynamicPagesService';

export const ManageDynamicPageSettingsSEO = () => {
  const { show } = useContext(SnackbarContext);
  const { selectedAccount } = useContext(UserContext);
  const { selectedDynamicPage, accountConfig } = useContext(DashboardContext);

  const updateDynamicPageData = useCallback(
    async (data: any, mergeFields: string[]) => {
      if (!selectedAccount || !selectedDynamicPage) return;
      try {
        await updateDynamicPage(
          selectedAccount.id,
          selectedDynamicPage.id,
          data,
          mergeFields,
        );
        show('Updated');
      } catch (_) {
        show('Failed to update');
      }
    },
    [selectedAccount, selectedDynamicPage, show],
  );

  const updateSEO = useCallback(
    async (seo: Partial<SEOConfig>) => {
      if (!selectedDynamicPage) return;

      updateDynamicPageData(
        {
          config: {
            seo: seo,
          },
        },
        Object.keys(seo).map((key) => `config.seo.${key}`),
      );
    },
    [selectedDynamicPage, updateDynamicPageData],
  );

  return (
    <div>
      <SettingSectionTitle
        title="SEO"
        description="Edit SEO for the dynamic page."
      />

      <SEOForm
        seo={{
          ...accountConfig?.seo,
          ...selectedDynamicPage?.data().config?.seo,
        }}
        onChange={updateSEO}
        showReset={{
          account: true,
        }}
        onReset={() => {
          updateDynamicPageData(
            {
              config: {
                seo: {},
              },
            },
            ['config.seo'],
          );
        }}
      />
    </div>
  );
};
